{
  "blog.title": "Blog",
  "blog.lead": "Articles per language: AI proposes a draft, you rewrite and approve.",
  "blog.lead_site": "Articles for {site}: AI proposes a draft, you rewrite and approve.",
  "blog.site": "Site",
  "blog.new": "New article",
  "blog.publish": "Publish",
  "blog.publish_count": "{count, plural, one {Publish one article} other {Publish # articles}}",
  "blog.published_title": "Publication started",
  "blog.published_body": "Revision r{revision} with {count, plural, one {one article} other {# articles}} goes to the website.",
  "blog.publish_failed": "Publishing failed",
  "blog.tabs": "Blog sections",
  "blog.tab_posts": "Articles",
  "blog.tab_calendar": "Calendar",
  "blog.tab_sources": "Sources",
  "blog.empty_title": "No articles yet",
  "blog.empty_body": "Start with a brief: topic, keyword and the languages with the reader's country.",
  "blog.blocking": "{count, plural, one {# blocking item} other {# blocking items}}",
  "blog.no_blocking": "No blocking items",
  "blog.warnings": "{count, plural, one {# point of attention} other {# points of attention}}",
  "blog.words": "{count, plural, one {# word} other {# words}}",
  "blog.status.brief": "Brief",
  "blog.status.in_progress": "In progress",
  "blog.status.ready": "Ready to publish",
  "blog.status.published": "Published",
  "blog.status.archived": "Archived",
  "blog.locale_status.empty": "No text yet",
  "blog.locale_status.draft": "Draft",
  "blog.locale_status.in_review": "In review",
  "blog.locale_status.approved": "Approved",
  "blog.locale_status.rejected": "Rejected",
  "blog.locale_status.live": "Live",
  "blog.cal_prev": "Previous month",
  "blog.cal_next": "Next month",
  "blog.cal_plan": "Plan an article on {date}",
  "blog.cal_free_week": "Week {week} of this month is still free",
  "blog.cal_full": "Every week of this month has an article",
  "blog.src_title": "Source list",
  "blog.src_lead": "Facts that differ per reader's country (tax, financing, NIE) only come from here. AI mentions nothing that is not listed here.",
  "blog.src_add": "Add source",
  "blog.src_edit": "Edit source",
  "blog.src_dialog_body": "A source is an authority or document with one or more facts, worded per language. Record which reader's country the source applies to.",
  "blog.src_general": "For every reader",
  "blog.src_publisher": "Publisher",
  "blog.src_name": "Title",
  "blog.src_url": "Address (https)",
  "blog.src_url_hint": "Public source; leave empty for your own product facts and fill in a reference instead.",
  "blog.src_reference": "Internal reference",
  "blog.src_country": "Reader's country",
  "blog.src_country_hint": "For example the Netherlands for box 3. Spanish rules apply to every reader.",
  "blog.src_topic": "Topic",
  "blog.src_status_label": "Status",
  "blog.src_status.active": "Active",
  "blog.src_status.needs_check": "To check",
  "blog.src_status.retired": "Retired",
  "blog.src_checked_on": "Checked on",
  "blog.src_checked": "checked {date}",
  "blog.src_used": "{count, plural, =0 {not used yet} one {in # language version} other {in # language versions}}",
  "blog.src_facts": "Facts",
  "blog.src_facts_hint": "One fact per block, as literal and careful as possible. Word it in every language you write about it in.",
  "blog.src_fact_in": "Fact {n} ({locale})",
  "blog.src_fact_add": "Add fact",
  "blog.src_fact_remove": "Remove fact",
  "blog.src_note": "Note",
  "blog.src_saved": "Source saved",
  "blog.topic.tax": "Tax",
  "blog.topic.financing": "Financing",
  "blog.topic.nie": "NIE",
  "blog.topic.purchase_process": "Buying process",
  "blog.topic.costs": "Costs",
  "blog.topic.residency": "Residency",
  "blog.topic.inheritance": "Inheritance",
  "blog.topic.rental": "Rental",
  "blog.topic.area": "Area",
  "blog.topic.product": "Product",
  "blog.topic.general": "General",
  "blog.brief_title": "New brief",
  "blog.brief_body": "What the article should answer and for whom. AI writes a draft per language with facts from your source list.",
  "blog.brief_topic": "Topic",
  "blog.brief_topic_hint": "The question or topic, for example getting an NIE and tax after buying.",
  "blog.brief_keyword": "Main keyword",
  "blog.brief_secondary": "Other keywords",
  "blog.brief_secondary_hint": "Separated by commas",
  "blog.brief_category": "Category",
  "blog.brief_no_category": "No category",
  "blog.brief_planned": "Planned for",
  "blog.brief_angle": "Angle",
  "blog.brief_angle_hint": "What does the reader know or can do afterwards?",
  "blog.brief_locales": "Languages",
  "blog.brief_locales_hint": "The reader's country per language: it decides which country facts (tax, financing) apply.",
  "blog.brief_locales_hint_product": "A keyword per language, if it differs from the main keyword.",
  "blog.brief_reader": "Reader's country",
  "blog.brief_locale_keyword": "Keyword in this language",
  "blog.brief_areas": "Linked areas",
  "blog.brief_create": "Create brief",
  "blog.edit_brief": "Edit brief",
  "blog.locales": "Language versions",
  "blog.live_at": "Live at {path}",
  "blog.for_country": "For readers from {country}",
  "blog.for_everyone": "For every reader",
  "blog.keyword_is": "keyword {keyword}",
  "blog.origin.ai": "AI draft",
  "blog.origin.ai_edited": "AI draft, edited",
  "blog.origin.human": "Written by a person",
  "blog.ai_draft": "Create AI draft",
  "blog.ai_again": "New AI draft",
  "blog.ai_done": "AI draft ready",
  "blog.ai_done_body": "{count, plural, =0 {No blocking items.} one {One blocking item to resolve.} other {# blocking items to resolve.}}",
  "blog.ai_done_test": "Outline from the test adapter: rewrite every text before you approve.",
  "blog.ai_failed": "AI draft failed",
  "blog.saved": "Saved",
  "blog.save_failed": "Saving failed",
  "blog.submit": "Submit for review",
  "blog.submitted": "Submitted for review",
  "blog.submit_failed": "Submitting failed",
  "blog.approve": "Approve",
  "blog.request_changes": "Request changes",
  "blog.approved_by": "Approved on {date}",
  "blog.approve_title": "Approve {locale}",
  "blog.approve_body": "You approve exactly this text. Any later change needs a new review.",
  "blog.approved_toast": "Approved",
  "blog.changes_title": "Request changes",
  "blog.changes_body": "Describe what needs to change. The language version goes back to draft.",
  "blog.changes_toast": "Back to draft",
  "blog.checklist": "Checklist",
  "blog.checklist_facts": "I checked every fact against the sources",
  "blog.checklist_country": "The advice fits the reader's country",
  "blog.checklist_noPromises": "There are no promises about returns, availability or outcomes",
  "blog.checklist_links": "The links are right and point to the correct pages",
  "blog.checklist_hint": "Tick every item to approve.",
  "blog.review_note": "Review note",
  "blog.test_title": "Test output, no language model",
  "blog.test_body": "This outline comes from the test adapter: facts from the source list under headings, with [TEST] marks. Rewrite every text. Approval is only possible once no mark is left; the database enforces this too.",
  "blog.empty_locale_title": "No text in this language yet",
  "blog.empty_locale_body": "Let AI create a draft with {facts, plural, one {# fact} other {# facts}} from the source list and {targets, plural, one {# link target} other {# link targets}}, or write it yourself.",
  "blog.editor_label": "Text in {locale}",
  "blog.f_title": "Title (H1)",
  "blog.f_seo_title": "SEO title",
  "blog.f_slug": "Slug",
  "blog.slug_hint": "Lowercase and hyphens; becomes the address of the article.",
  "blog.slug_fixed": "The address is fixed since the first publication.",
  "blog.f_meta": "Meta description",
  "blog.counter": "{n} characters (aim for {min} to {max})",
  "blog.f_excerpt": "Summary",
  "blog.f_intro": "Introduction",
  "blog.f_sections": "Sections",
  "blog.f_level": "Level",
  "blog.f_heading": "Heading {n}",
  "blog.f_paragraph": "Paragraph {n}",
  "blog.f_bullets": "Bullet list",
  "blog.f_bullets_hint": "One item per line",
  "blog.add_paragraph": "Add paragraph",
  "blog.add_section": "Add section",
  "blog.move_up": "Move section up",
  "blog.move_down": "Move section down",
  "blog.remove_section": "Remove section",
  "blog.f_faq": "Questions",
  "blog.f_q": "Question {n}",
  "blog.f_a": "Answer {n}",
  "blog.add_faq": "Add question",
  "blog.remove_faq": "Remove question",
  "blog.f_links": "Internal links",
  "blog.f_links_hint": "The label must appear literally in the chosen paragraph; the site turns it into a link to the target's page.",
  "blog.f_link_label": "Label",
  "blog.f_link_missing": "This label is not in the chosen paragraph",
  "blog.f_link_place": "In",
  "blog.f_link_target": "To",
  "blog.add_link": "Add link",
  "blog.remove_link": "Remove link",
  "blog.place_intro": "Introduction",
  "blog.place": "{section}, paragraph {paragraph}",
  "blog.target.area": "Area",
  "blog.target.property": "Property",
  "blog.target.post": "Article",
  "blog.target.page": "Page",
  "blog.page.contact": "Contact",
  "blog.page.sell": "Sell",
  "blog.page.properties": "All properties",
  "blog.page.areas": "Areas",
  "blog.page.demo": "Request a demo",
  "blog.page.switch": "Switching",
  "blog.page.blog": "Blog overview",
  "blog.page.pricing": "Pricing",
  "blog.side_label": "Checks and preview",
  "blog.snippet": "Roughly in search results",
  "blog.snippet_empty": "No title yet",
  "blog.snippet_empty_desc": "No meta description yet",
  "blog.checks": "Checks",
  "blog.checks_live": "Live; duplicate and overlap check on save",
  "blog.checks_saved": "Last saved version",
  "blog.checks_ok": "{count, plural, one {# check passed} other {# checks passed}}",
  "blog.sev_block": "Blocks approval",
  "blog.sev_warn": "Point of attention",
  "blog.facts": "Facts from the source list",
  "blog.facts_hint": "Tick which facts the article uses. Numbers in the text must appear in a ticked fact.",
  "blog.facts_empty": "No active facts for this country. Add them under Sources.",
  "blog.history": "History",
  "chat.title": "Chatbot",
  "chat.lead": "Conversations, settings and knowledge of the chatbot on your website.",
  "chat.lead_site": "Conversations, settings and knowledge of the chatbot on {site}.",
  "chat.tabs": "Chatbot sections",
  "chat.tab_conversations": "Conversations",
  "chat.tab_settings": "Settings",
  "chat.tab_knowledge": "Knowledge",
  "chat.stat_conversations": "Conversations (30 days)",
  "chat.stat_turns": "Questions answered",
  "chat.stat_leads": "Enquiries from chat",
  "chat.stat_cost": "Costs",
  "chat.filter": "Show",
  "chat.f_all": "All",
  "chat.f_lead": "With enquiry",
  "chat.f_open": "Without enquiry",
  "chat.search": "Search conversations",
  "chat.search_placeholder": "Word from a question or answer",
  "chat.no_question": "No question",
  "chat.turns": "{count, plural, one {# question} other {# questions}}",
  "chat.mobile": "Mobile",
  "chat.desktop": "Desktop",
  "chat.status_lead": "Enquiry",
  "chat.test": "Test",
  "chat.empty_title": "No conversations yet",
  "chat.empty_body": "As soon as visitors use the chatbot on your site, the conversations appear here.",
  "chat.conversation": "Conversation of {date}",
  "chat.unknown_page": "unknown page",
  "chat.lead_made": "Enquiry created: {name}",
  "chat.open_lead": "Open enquiry from {name}",
  "chat.visitor": "Visitor",
  "chat.assistant": "Assistant",
  "chat.feedback_bad": "The visitor found this answer unhelpful",
  "chat.test_answer": "Test answer without a language model",
  "chat.ref.property": "Property",
  "chat.ref.page": "Page",
  "chat.ref.post": "Article",
  "chat.ref.area": "Area",
  "chat.s_general": "General",
  "chat.s_active_on": "The chatbot is on for the site",
  "chat.s_active_off": "The chatbot is paused",
  "chat.s_active_hint": "Pausing works immediately; the button disappears after the next publication.",
  "chat.s_name": "Assistant name",
  "chat.s_tone": "Tone",
  "chat.tone.warm": "Warm and personal",
  "chat.tone.business": "Businesslike and precise",
  "chat.tone.brief": "Short and to the point",
  "chat.s_texts": "Greeting and quick buttons",
  "chat.s_language": "Language",
  "chat.s_greeting": "Greeting ({locale})",
  "chat.s_quick": "Quick buttons (at most four)",
  "chat.s_quick_label": "Button {n}",
  "chat.s_quick_prompt": "Question behind button {n}",
  "chat.s_quick_add": "Add button",
  "chat.s_remove": "Remove",
  "chat.s_look": "Look",
  "chat.s_look_hint": "Colours come from the site's design system; choose which set.",
  "chat.s_palette": "Colour set",
  "chat.palette.brand": "Brand colour",
  "chat.palette.deep": "Dark",
  "chat.palette.warm": "Warm",
  "chat.s_position": "Place on the page",
  "chat.pos_end": "Bottom right",
  "chat.pos_start": "Bottom left",
  "chat.s_limits": "Handover and limits",
  "chat.s_handoff": "Visitors can turn their question into an enquiry, with consent",
  "chat.s_handoff_product": "Visitors can request a demo or contact, with consent",
  "chat.s_turns": "Questions per conversation",
  "chat.s_turns_hint": "After that the chatbot suggests getting in touch.",
  "chat.s_daily": "Cost cap per day",
  "chat.s_daily_hint": "On top of the organisation's monthly budget.",
  "chat.s_updated": "Last changed {date}",
  "chat.saved": "Settings saved",
  "chat.save_failed": "Saving failed",
  "chat.k_title": "Chatbot knowledge",
  "chat.k_lead": "Besides the current listings and the published blog, the chatbot only uses these texts: questions, the office, the buying process and costs.",
  "chat.k_lead_product": "Besides the published blog, the chatbot only uses these texts about the product.",
  "chat.k_add": "Add knowledge",
  "chat.k_edit": "Edit knowledge",
  "chat.k_dialog_body": "One question or topic per item, with the answer the chatbot may give. Optionally a page the answer points to.",
  "chat.k_kind": "Kind",
  "chat.kind.faq": "Question",
  "chat.kind.company": "Office",
  "chat.kind.process": "How we work",
  "chat.kind.costs": "Costs",
  "chat.kind.area": "Area",
  "chat.kind.product": "Product",
  "chat.k_locale": "Language",
  "chat.k_page": "Points to",
  "chat.k_no_page": "No page",
  "chat.k_active": "Active",
  "chat.k_inactive": "Inactive",
  "chat.k_question": "Question or title",
  "chat.k_answer": "Answer",
  "chat.k_answer_hint": "Only what you would say yourself. No promises about prices or outcomes.",
  "blog.check.test_output": "The text still contains test output ([TEST]).",
  "blog.check_ok.test_output": "No test output",
  "blog.check.title": "Title of {length} characters; aim for 20 to 75.",
  "blog.check_ok.title": "Title length",
  "blog.check.seo_title": "SEO title of {length} characters; aim for 30 to 60.",
  "blog.check_ok.seo_title": "SEO title",
  "blog.check.meta_description": "Meta description of {length} characters; aim for 120 to 160.",
  "blog.check_ok.meta_description": "Meta description",
  "blog.check.keyword_title": "Keyword \"{keyword}\" is not in the title or SEO title.",
  "blog.check_ok.keyword_title": "Keyword in the title",
  "blog.check.keyword_intro": "Keyword \"{keyword}\" is not in the introduction.",
  "blog.check_ok.keyword_intro": "Keyword in the introduction",
  "blog.check.keyword_heading": "No heading contains a keyword.",
  "blog.check_ok.keyword_heading": "Keyword in a heading",
  "blog.check.keyword_slug": "The slug does not contain the keyword.",
  "blog.check_ok.keyword_slug": "Keyword in the slug",
  "blog.check.headings": "Headings: at least two H2s, H3 only under an H2, unique and different from the title ({issues}).",
  "blog.check_ok.headings": "Heading structure",
  "blog.check.length": "{words} words; a good article has 600 to 2,500 (below 300 is not allowed).",
  "blog.check_ok.length": "Length",
  "blog.check.internal_links": "Internal links: {count} (at least 2 to different targets), labels not found in the paragraph: {badLabels}.",
  "blog.check_ok.internal_links": "Internal links",
  "blog.check.link_targets": "Link targets: link to an area or property and only to existing pages ({invalid}).",
  "blog.check_ok.link_targets": "Link targets exist",
  "blog.check.faq": "{count} questions; two or more help readers and search engines.",
  "blog.check_ok.faq": "Questions",
  "blog.check.facts_known": "{unknown} fact(s) are not in the source list for this country.",
  "blog.check_ok.facts_known": "Facts from the source list",
  "blog.check.numbers": "Numbers without a source in the text: {numbers}. Only use numbers from linked facts or properties.",
  "blog.check_ok.numbers": "Numbers with a source",
  "blog.check.country_facts": "No fact for readers from {country}: the article then only gives general advice.",
  "blog.check_ok.country_facts": "Facts for the reader's country",
  "blog.check.unique_title": "Title or slug already exists on this site: {titles}.",
  "blog.check_ok.unique_title": "Unique title and slug",
  "blog.check.cannibalization": "Another article uses the same main keyword: {titles}.",
  "blog.check_ok.cannibalization": "Own keyword",
  "blog.check.overlap": "{percent}% of the text overlaps with another article (at most 20%).",
  "blog.check_ok.overlap": "No duplicate content",
  "blog.check.readability": "Average of {average} words per sentence; shorter reads easier (24 or fewer).",
  "blog.check_ok.readability": "Readability",
  "blog.check.copy": "Copy rules: {rules}.",
  "blog.check_ok.copy": "Copy rules",
  "chat.s_privacy": "Privacy",
  "chat.s_retention": "Keep conversations for (days)",
  "chat.s_retention_hint": "Between 30 and 730 days. After that BRES deletes the messages; the counts stay for the statistics.",
  "chat.s_retention_note": "Conversations a visitor turns into an enquiry stay with that enquiry. The chatbot states the period in the chat window; the site's privacy statement follows after the next publication."
}
